<template>

  <ModalContainer queryParam="nut" ref="modalContainer" size="xl">

    <b-card>
      <h3 class="modal-title">Informe de la Terapia Nutricional.</h3>

      <b-tabs card>


        <b-tab title="Detalles del paciente">         
        <b-card bg-variant="light" text-variant="dark">
          <div class="row">
          <b-col class="col-6">
            <b-row class="mb-1">
              <b >Paciente: </b>{{ dataTerapia.pacienteNombre }}
            </b-row>
            <b-row class="mb-1">
              <b>Nombre de terapia:</b>
              <span>{{ dataTerapia.nombre }}</span>
            </b-row>
          </b-col>
          <b-col class="col-6">
            <b-row>
            <b >Fecha de sesion:</b>
          <span >{{ dataTerapia.fechaSesion }}</span>
          </b-row>
            <b-row class="mt-1">
            <b >Motivo de Solicitud:</b>
          <span >{{ dataTerapia.motivoSolicitud }}</span>
          </b-row>
            <b-row class="mt-1">
            <b >Resumen / Plan Terapeutico:</b>
          <span >{{ dataTerapia.resumenClinico }}</span>
          </b-row>
          </b-col>
          </div>
        </b-card>
           
          <NutricionalDetallesPaciente :dataTerapia="dataTerapia" :dataForm = "dataFormGuardado" @update-nutricional="recibirDatos" class="my-0" />
        </b-tab> 
        <b-tab title="Agregar Firma">
           <ProcessSignature  :base64Signature="dataTerapia.signatureBlob"
            @signatureBlob="firmaRecibida" />
        </b-tab>
        <!-- 
        <b-tab title="Examenes">
          <b-row>
            <b-col>
              <label class="text-muted"> Examenes</label>
              <b-table responsive small :items="imagenes" />
              <b-table responsive small :items="laboratorios" />
            </b-col>
          </b-row>
        </b-tab> -->
      </b-tabs>

      <b-row class="mt-3">
        <b-col class="text-right">
          <!-- <b-button variant="secondary" class="mr-1">
            Cancelar
          </b-button> -->

          <b-button variant="primary" @click="onSaveFormSesion()">
            Guardar
          </b-button>
        </b-col>
      </b-row>

    </b-card>

   
  </ModalContainer>

  

</template>

<script>

import { ModalContainer } from '@/shared/components';
import NutricionalDetallesPaciente from './NutricionalDetallesPaciente.vue';
import { sesionesTerapiaService } from '../services';
import ProcessSignature from '../../topaz/components/ProcessSignature.vue';


export default {

  name: 'FormTerapiaNutricional',

  components: {
    NutricionalDetallesPaciente,
    ModalContainer,
    ProcessSignature,
  },

  data() {
    return {
      sesionesTerapiaService,
      urlFirmaPaciente: '',
      idSolicitudTerapia: null,
      tokenSesion:null,
      dataForm:null,
      dataFormGuardado:null,

      dataTerapia: {
        pacienteNombre:'',
        nombre:'',
        fechaSesion:'',
        signaturePersona: null,
        signatureBlob: null,
      },

      nuevaFirma : '',
    }
  },

    watch:{

    '$route.query.nut':
    {
      deep:true,
      immediate:true,
      async handler(newValue){
        if(newValue){
          this.dataFormGuardado = null
          await this.loadData()
        }
      }
    }
  },


  methods: {

 
    recibirDatos(nuevoValor) {
      console.log("nuevo valor", nuevoValor)
      this.dataForm = nuevoValor
    },

      firmaRecibida(blob) {
      this.nuevaFirma = blob;
    },



     async loadData() {


      this.tokenSesion = this.$route.query.nut;

      const dataResponse = await this.sesionesTerapiaService.obtenerDataSesionTerapia(this.tokenSesion)
      const sesionTerapia = dataResponse.sesionTerapia
      const paciente = dataResponse.paciente
      this.dataTerapia.pacienteNombre = `${paciente.persona.primerApellido} ${paciente.persona.primerNombre}`
      this.dataTerapia.nombre = sesionTerapia.solicitudTerapia.terapia.nombre
      this.dataTerapia.fechaSesion = sesionTerapia.fechaSesion
      this.dataTerapia.motivoSolicitud = sesionTerapia.solicitudTerapia.motivoSolicitud
      this.dataTerapia.resumenClinico = sesionTerapia.solicitudTerapia.resumenClinico
      

      console.log("llega data terapia", this.dataTerapia)

      try{
        if(dataResponse){
          
          let dataForm = JSON.parse(dataResponse.sesionTerapia.dataFormulario)
          this.dataFormGuardado = dataForm
        }
      }catch(error){
        console.error("error parseo", error)
      }

    },

      async onSaveFormSesion() {
      let dataForm = ''
      if (this.dataForm) {
        this.dataForm.firmaBlob = this.nuevaFirma ? this.nuevaFirma : ''
        dataForm = JSON.stringify(this.dataForm)
      }
      

      const response = await this.sesionesTerapiaService.saveDataSesionTerapia(this.tokenSesion, dataForm)

      if (response) {
        // Cerrar el modal al guardar correctamente
        if (this.$refs.modalContainer && this.$refs.modalContainer.closeModal) {
          await this.$refs.modalContainer.closeModal();
        }
        this.$swal.fire({
          icon: 'success',
          title: 'Datos guardados',
          text: 'La sesión de terapia se guardó correctamente.',
          confirmButtonText: 'Aceptar'
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'No se pudo guardar la sesión de terapia. Por favor, intenta de nuevo.',
          confirmButtonText: 'Cerrar'
        });

      }
    },
  }

}
</script>
